// /opt/isp_erp/frontend/src/components/ftth/LeafletDrawIntegration.jsx
import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet-draw';
import 'leaflet-draw/dist/leaflet.draw.css';

/**
 * Integración directa de leaflet-draw con react-leaflet.
 * Evita el bug "options.featureGroup must be a L.FeatureGroup".
 *
 * @param {boolean} activo - Si está en true, muestra las herramientas de dibujo
 * @param {function} onCreated - Callback cuando se crea una geometría
 * @param {string} mode - "polyline" | "polygon" | "marker" (default: polyline)
 */
export default function LeafletDrawIntegration({
  activo,
  onCreated,
  mode = 'polyline',
}) {
  const map = useMap();
  const drawnItemsRef = useRef(null);
  const controlRef = useRef(null);

  useEffect(() => {
    if (!activo) return;

    // 1. FeatureGroup donde leaflet-draw guarda las geometrías
    const drawnItems = new L.FeatureGroup();
    map.addLayer(drawnItems);
    drawnItemsRef.current = drawnItems;

    // 2. Control de dibujo
    const drawControl = new L.Control.Draw({
      position: 'topright',
      draw: {
        polygon: mode === 'polygon'
          ? { shapeOptions: { color: '#ff9800', weight: 3 } }
          : false,
        polyline: mode === 'polyline'
          ? { shapeOptions: { color: '#ff9800', weight: 3 } }
          : false,
        rectangle: false,
        circle: false,
        circlemarker: false,
        marker: mode === 'marker' ? true : false,
      },
      edit: {
        featureGroup: drawnItems,
        edit: false,
        remove: false,
      },
    });
    map.addControl(drawControl);
    controlRef.current = drawControl;

    // 3. Callback al terminar de dibujar
    const handleCreated = (e) => {
      const { layer } = e;
      drawnItems.addLayer(layer);
      if (onCreated) onCreated(e);
    };

    map.on(L.Draw.Event.CREATED, handleCreated);

    // 4. Cleanup
    return () => {
      map.off(L.Draw.Event.CREATED, handleCreated);
      if (controlRef.current) {
        map.removeControl(controlRef.current);
        controlRef.current = null;
      }
      if (drawnItemsRef.current) {
        map.removeLayer(drawnItemsRef.current);
        drawnItemsRef.current = null;
      }
    };
  }, [map, activo, onCreated, mode]);

  return null;
}
